'use strict';

var config = {
        WIDGET_PREFIX: 'iVis',
        WIDGET_ID_PARAM_NAME: 'widgetId',
        LOCALIZATIONS: [
            { id: 'en', value: 'English', default: true },
            { id: 'it', value: 'Italiano' },
            { id: 'cz', value: 'Czechia' },
            { id: 'ro', value: 'Romanian'},
            { id: 'hu', value: 'Hungary'},
            { id: 'pl', value: 'Poland' },
            { id: 'cz', value: 'Czech Republic'}
        ],
        LOCALIZATIONS_LOCATION: '../locales'
    };

// expose based on requesting environment
define('shared/config', [], function () {
    return config;
});



//////////////////
// WEBPACK FOOTER
// ./src/shared/config.js
// module id = 2
// module chunks = 0 1